{
  "version": 1,
  "asset_id": "f56b7c48-352e-4b1e-9476-6cbbbf2cc19e",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/f56b7c48-352e-4b1e-9476-6cbbbf2cc19e/sleeve-fitzer-1.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/f56b7c48-352e-4b1e-9476-6cbbbf2cc19e/sleeve-fitzer-1.webp",
  "original_filename": "sleeve-fitzer-1.webp",
  "size": 15172,
  "content_type": "image/webp",
  "created_at": "2026-08-15T18:29:12Z"
}
